import { clamp, priceY } from './chart-data';
import type { Scale } from './chart-data';

export type BidAsk = { time: number; bid: number; ask: number };
export function validBidAsk(value: BidAsk | null | undefined, now = Date.now()): value is BidAsk {
  return Boolean(value && Number.isSafeInteger(value.time) && value.time > 0 && value.time <= now + 10000 &&
    Number.isFinite(value.bid) && value.bid > 0 && Number.isFinite(value.ask) && value.ask >= value.bid);
}
export function currentBidAsk(value: BidAsk | null | undefined, now: number, quoteTime: number) {
  return validBidAsk(value, now) && value.time === quoteTime && now - value.time < 10000 ? value : null;
}

// Only labels move apart. Price lines stay at the exact bid/ask coordinates.
export function bidAskLayout(book: BidAsk, scale: Scale) {
  const height = 30, gap = 4;
  const levels = [
    { side: 'BUY', type: 'ASK', price: book.ask, color: '#1263b5' },
    { side: 'SELL', type: 'BID', price: book.bid, color: '#bf3446' },
  ].map(level => ({ ...level, y: priceY(level.price, scale), labelTop: 0 }))
    .filter(level => level.y >= scale.top && level.y <= scale.bottom);
  for (const level of levels) level.labelTop = clamp(level.y - height / 2, scale.top, scale.bottom - height);
  if (levels.length === 2 && levels[1].labelTop - levels[0].labelTop < height + gap) {
    const mid = (levels[0].y + levels[1].y) / 2;
    levels[0].labelTop = clamp(mid - height - gap / 2, scale.top, scale.bottom - 2 * height - gap);
    levels[1].labelTop = levels[0].labelTop + height + gap;
  }
  return levels;
}
